import React from 'react';
import googlePlay from '../../assets/images/svg/google-play.svg';
const GetTheApp = () => {
  return (
    <div className="get-app" data-aos="fade-left">
      <div>
        <h3>Get The App</h3>
        <img src={googlePlay} alt="Google Play" />
      </div>
    </div>
  );
};

export default GetTheApp;
